import { render, staticRenderFns } from "./DashboardParamList.vue?vue&type=template&id=1bfb1676"
import script from "./DashboardParamList.vue?vue&type=script&lang=js"
export * from "./DashboardParamList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports